import React, { useEffect, useState } from "react";
import "./HomeBlog.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const HomeBlogs = ({ category, theme }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [blogs, setBlogs] = useState([]);
  // ✅ Detect Mobile Screen Size
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  async function getAllBlogs() {
    try {
      const res = await axios.get("/api/blog/get-all-blog");
      if (res.data.success) {
        let allBlogs = res.data.data.reverse();

        // ✅ If category is provided, filter blogs that include it
        if (category) {
          allBlogs = allBlogs.filter(
            (b) =>
              Array.isArray(b.categories) &&
              b.categories.some(
                (c) => c.toLowerCase() === category.toLowerCase()
              )
          );
        }
// ✅ If theme is provided, filter blogs that include it
else if (theme) {
  allBlogs = allBlogs.filter(
    (b) =>
      Array.isArray(b.travelTheme) &&
      b.travelTheme.some(
        (t) => t.toLowerCase() === theme.toLowerCase()
      )
  );
}

        setBlogs(allBlogs);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

 useEffect(() => {
  getAllBlogs();
}, [category, theme]);

  const calculateReadingTime = (text) => {
    const wordsPerMinute = 200;
    const wordCount = text?.trim().split(/\s+/).length || 0;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  function handleNavigate(title) {
    navigate(`/blog/${title.replace(/\s+/g, "-")}`);
  }

  // ✅ Determine how many blogs to show
  const isCategoryPage = category || location.pathname.includes("/category");

const blogsToShow = isCategoryPage
  ? isMobile
    ? blogs.slice(0, 1) // ✅ On mobile: show only 1
    : blogs.slice(0, 8) // ✅ On desktop: show 8
  : isMobile
  ? blogs.slice(0, 1)
  : blogs.slice(0, 8);


  return (
    <div
      className={`home-blog-container Mon_font ${
        location.pathname !== "/" ? "bg-white" : ""
      }`}
    >
    <h2 className="text-center">
  {category
    ? `${category} Blogs`
    : theme
    ? `${theme} Blogs`
    : "Our Blogs"}
</h2>

      <p className="text-center">
        "Discover these enlightening reads to elevate your travel experiences!"
      </p>
      <div className="hr-line"></div>

      <div className="blog-grid">
        {blogsToShow.map((item, index) => (
          <div
            className="blog-card"
            key={index}
            style={{
              backgroundImage: `url(https://highmountains.in/blogImages/${item?.image})`,
            }}
            onClick={() => handleNavigate(item?.title)}
          >
            <div className="overlay">
              <h3 className="title">{item?.title}</h3>
              <span className="read-more-btn">Read More →</span>
              <div className="blog-meta">
                <span className="time">
                  {calculateReadingTime(item.description)} min read
                </span>
                <span className="author">{item?.author}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Hide "View All Blogs" button on category pages */}
      {blogs.length > blogsToShow.length && (
  <div className="home-blog-btn">
    <button onClick={() => navigate("/blog")}>View All Blogs</button>
  </div>
)}

    </div>
  );
};

export default HomeBlogs;
